import { CustomersApiRemoteService } from '../../Services/api/customers/customers-service'
import { ICustomerEntity, ICustomerListResponse, IListCustomersPayload } from '../../Services/api/customers/customers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowCustomersUseCase
implements IFormUsecase<string, ICustomerEntity> {
  constructor (private readonly CustomersApi: CustomersApiRemoteService) {}
    

  public async handle (customerId: string): Promise<Result<ICustomerEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CustomersApi.show(customerId)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
